import { canUseDOM, canUseLocalStorage } from '@ps/web-core-utils';
import addDays from 'date-fns/addDays';
import type { AnyAction, Dispatch, Middleware } from 'redux';

import { select } from '..';
import type { RootState } from '../types';

export const BET_SLIP_PERSIST_VERSION = '1.0.0';

const persistBetSlipStateMiddleware: Middleware<object, RootState> =
  (storeApi) => (next) => (action: AnyAction) => {
    const result = next(action);

    if (typeof action.type === 'string' && action.type.startsWith('betSlip/')) {
      const state = storeApi.getState();
      const hasRehydrated = select.betSlip.hasRehydrated(state);

      if (hasRehydrated) {
        const persistState = select.betSlip.persistedState(state);
        const exp = addDays(new Date(), 1).toISOString();
        localStorage.setItem(
          'betSlip',
          JSON.stringify({ ...persistState, exp, version: BET_SLIP_PERSIST_VERSION })
        );
      }
    }

    return result;
  };

export default canUseDOM && canUseLocalStorage
  ? persistBetSlipStateMiddleware
  : () => (next: Dispatch<AnyAction>) => (action: AnyAction) => next(action);
